import { render, staticRenderFns } from "./VaInputWrapper.demo.vue?vue&type=template&id=20652fa9&"
import script from "./VaInputWrapper.demo.vue?vue&type=script&lang=js&"
export * from "./VaInputWrapper.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports